const WorkExperience = [
    {
        id: 1,
        title: "Senior Deep Learning Engineer",
        company: "HCLTech",
        yearsActive: "April 2019 - January 2023",
        information: [
            "Created and assisted with the development of 12 official university sponsored AI-products and provided training for continuous updating of products.",
            "Created charts in Jupyter Notebook to perform bitcoin price analysis with 98% accuracy & visualize data using Matplotlib.",
            "Developed and deployed a DL model for a financial services client, resulting in a 25% reduction in fraudulent transactions and saving the client $500k annually.",
            "Built a pair of multi-layer neural networks and generated, new, realistic faces using GAN(Generative Adversarial Network) on PyTorch environment."
        ],
    },
    {
        id: 2,
        title: "Natural Language Processing Expert",
        company: "OpenText",
        yearsActive: "November 2015 - March 2019",
        information: [
            "Trained an attention-based encoder-decoder model to check grammar error.",
            "Developed Chinese-English machine translation system that outperformed Google Translation using Transformers and some manually organizing models.",
            "Spearheaded the transition from Firebase to AWS, saving the company $27000+ monthly and increasing load speeds by an average of 42%.",
        ],
    },
    {
        id: 3,
        title: "Junior Deep Learning Engineer",
        company: "TouchBistro",
        yearsActive: "May 2013 - October 2015",
        information: [
            "Trained a CNN(Convolutional Neural Network) to analyze images of dogs and correctly identify their breeds. Using transfer learning to increase performance and simplify the model.",
            "Analyzed and interpreted data for a retail client to identify trends and patterns.",
            "Applied LSTM network to predict the pattern Assisted in creating a DL model that detects anomalies in the building process of a construction robot and machine reducing downtime by 83%.",
            "Conceived and created a machine learning algorithm that detects deviant behavior in robots using SIFT, HOG, and 20+ other computer vision methods.",
            "Tracked the health of 15+ robots using React/Redux with Node.js backend and Python scripts, which collected 100 TB of data from its sensors."
        ],
    },
];

export default WorkExperience;
